import React, { useState, useEffect } from "react";
import Navbar from "../../components/Navbar";
import {
  Container,
  Grid,
  Stack,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import BookingsCard from "./components/BookingsCard";
import SelectedBooking from "./components/SelectedBooking";
import _ from "lodash";
import { getUserBookings, getServiceProviderBookings } from "../../apis";

const MyBookings = () => {
  const user = JSON.parse(localStorage.getItem("user-info"));
  const userID = user?.googleId ? user.googleId : user._id;
  const userType = localStorage.getItem("user-type");

  const [activeData, setActiveData] = useState([]);
  const [pastData, setPastData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [active, setActive] = useState(true);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     const response = await myRequests(userID);
  //     setData(response.data.requests);
  //   };
  //   fetchData();
  // }, []);

  // useEffect(() => {
  //   if (data.length) {
  //     setLoading(false);
  //   }
  // }, [data]);

  // const RequestClickhandler = (id) => {
  //   const filteredResult = data.filter((item) => item._id == id);
  //   setSelectedRequest(filteredResult[0]);
  // };

  useEffect(() => {
    const fetchData = async () => {
      if (userType == "service provider") {
        const response = await getServiceProviderBookings(userID);
        setActiveData(response.data.activeRequests);
        setPastData(response.data.pastRequests);
        setLoading(false);
      } else {
        const response = await getUserBookings(userID);
        setActiveData(response.data.activeRequests);
        setPastData(response.data.pastRequests);
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const selectBooking = (index) => {
    setSelectedRequest(activeData[index]);
    setActive(true);
  };

  const selectBookingPast = (index) => {
    setSelectedRequest(pastData[index]);
    setActive(false);
  };

  const refreshApi = async () => {
    const response = await getUserBookings(userID);
    setActiveData(response.data.activeRequests);
    setPastData(response.data.pastRequests);
    setSelectedRequest(null);
    setLoading(false);
  };

  if (loading) {
    return (
      <>
        <Navbar />
        <Box
          sx={{ display: "flex" }}
          justifyContent="center"
          alignItems="center"
          style={{ height: "100vh" }}
        >
          <CircularProgress disableShrink />
        </Box>
      </>
    );
  } else {
    return (
      <>
        <Navbar />
        <div style={{ width: "90%", margin: "auto" }}>
          <Grid container spacing={4}>
            <Grid item sm={6}>
              <Container>
                <Typography
                  variant="h5"
                  className="mb-16 mt-16"
                  style={{ fontWeight: "bold" }}
                >
                  Active Bookings
                </Typography>
                <div
                  style={{ border: "1px solid #EEEBEF", borderRadius: "6px" }}
                  className="mb-16"
                >
                  <Stack spacing={2}>
                    {activeData.length ? (
                      activeData.map((item, index) => (
                        <BookingsCard
                          title={item.request.title}
                          name={item.bid.serviceProviderName}
                          index={index}
                          clickHandler={selectBooking}
                        />
                      ))
                    ) : (
                      <Typography>No active Bookings</Typography>
                    )}
                    {/* {data &&
                    data.map((request) => (
                      <FeedRequestCard
                        title={request.title}
                        location={request.address}
                        fromDate={request.fromDate}
                        urgent={request.urgent}
                        details={request.details}
                        id={request._id}
                        clickHandler={RequestClickhandler}
                      />
                    ))} */}
                  </Stack>
                </div>
                <Typography
                  variant="h5"
                  className="mb-16 mt-16"
                  style={{ fontWeight: "bold" }}
                >
                  Past Bookings
                </Typography>
                <div
                  style={{ border: "1px solid #EEEBEF", borderRadius: "6px" }}
                  className="mb-16"
                >
                  <Stack spacing={2}>
                    {/* {data &&
                    data.map((request) => (
                      <FeedRequestCard
                        title={request.title}
                        location={request.address}
                        fromDate={request.fromDate}
                        urgent={request.urgent}
                        details={request.details}
                        id={request._id}
                        clickHandler={RequestClickhandler}
                      />
                    ))} */}
                    {pastData.length ? (
                      pastData.map((item, index) => (
                        <BookingsCard
                          title={item.request.title}
                          name={item.bid.serviceProviderName}
                          index={index}
                          clickHandler={selectBookingPast}
                        />
                      ))
                    ) : (
                      <Typography>No past Bookings</Typography>
                    )}
                  </Stack>
                </div>
              </Container>
            </Grid>
            <Grid item sm={6}>
              {selectedRequest != null ? (
                <SelectedBooking
                  currentRequest={selectedRequest}
                  active={active}
                  ratingHandler={refreshApi}
                />
              ) : null}
              {/* <SelectedBooking /> */}
            </Grid>
          </Grid>
        </div>
      </>
    );
  }
};

export default MyBookings;
